<template lang="pug">
  .dashboard-inner.narrow-modal-body
    SectionTitle(text="Delete Address").app-modal-title
    .prompt Are you sure you would like to delete the following address?
    .row
      Address(:address="addressToDelete")

    .row
      SubmitButtons(submit-text="Delete" cancel-text="Cancel" :submit-method="onSubmit" :cancel-method="hideModal")
  
</template>

<script>
  import Address from "./Address";
  import SubmitButtons from '../SubmitButtons';
  import SectionTitle from "../SectionTitle";
  import { mapActions } from "vuex";

  export default {
    name: "AddressDeleteModal",
    
    components: {
      SectionTitle,
      Address,
      SubmitButtons
    },

    computed: {
      addressToDelete() {
        return this.$store.state.addressBook.addressToDelete;
      }
    },

    methods: {
      ...mapActions('modal', ['hideModal']),
      onSubmit() {
        this.hideModal();
        this.$store.dispatch('addressBook/deleteAddress');
      },

      cleanUp() {
        this.$store.commit('addressBook/clearAddressToDelete');
      }
    },

    beforeDestroy() {
      this.cleanUp();
    }
  }
</script>

<style scoped lang="stylus">

  .prompt
    padding 1em 0 2em

  .address
    padding-bottom 2em

</style>